module.exports = __webpack_public_path__ + "img/meet_ruby.76768f2d.png";